import file from '@/api/file';

const { checkBlobFile } = file();

export const checkFileExist = async (filesAttachment) => {
	const attachments = filesAttachment.map((f) => {
		const isPrivate = !!f.privilegelevelid?.find((p) => p.id === 99 && !!p.value)
		return { id: f.id, name: f.file.name, container: isPrivate ? 'bds-docs' : 'bds-docs-public' }
	})

	const fData = new FormData()

	fData.append('attachments', JSON.stringify(attachments));
	// filesAttachment.forEach((f, index) => {
	// 	fData.append(`files_uploaded[${index}]`, f.file);
	// })

	const response = await checkBlobFile(fData);

	const d = response.data?.files_to_upload || [];
	return { response: d, status: d.some((r) => r.status === 'exist') };
};
